// Pure helper extracted from the bracket seed editor (BracketMatchList) so
// the "where does the + Insert below button live?" logic can be tested
// without rendering the full match list.
//
// DUB-55: the Insert Below button should appear on the LAST card of each
// R1+PQ group — the R1 card when no PQs attach to it, or the last PQ card
// when there are. The button's payload is always the R1 match's id: the
// inserted match is a new R1 match, the caller just needs to know which R1
// "owns" the group so it can insert right after it (and after its PQs).
//
// Contract:
//  - `match` is a seed match with fields `id`, `round`, `matchNumber`,
//    and for PQ matches `feedsIntoRound` + `feedsIntoMatchNumber`.
//  - `idx` is this match's position in the rendered matches array.
//  - `matches` is the full in-order matches array.
//  - Returns the R1 match id to use as the insert anchor, or `null` if
//    this card should NOT show an Insert Below button.
export function resolveInsertAnchorMatchId(match, idx, matches) {
  if (!match) return null

  const next = matches[idx + 1]
  const isPQ = match.round === 0

  const groupContinues = next && next.round === 0 && (
    isPQ
      ? next.feedsIntoMatchNumber === match.feedsIntoMatchNumber
      : next.feedsIntoMatchNumber === match.matchNumber
  )
  if (groupContinues) return null

  if (isPQ) {
    const parent = matches.find(m =>
      m.round === match.feedsIntoRound &&
      m.matchNumber === match.feedsIntoMatchNumber
    )
    return parent?.id ?? null
  }

  if (match.round === 1) return match.id
  return null
}
